function getUserInitials(user) {
  let initials = '';
  if (user.firstName && user.lastName) {
    initials = `${user.firstName[0]}${user.lastName[0]}`;
  } else if (user.firstName) {
    initials = user.firstName[0] + user.firstName[1];
  } else if (user.lastName) {
    initials = user.lastName[0] + user.lastName[1];
  } else if (user.email) {
    initials = user.email[0] + user.email[1];
  }
  return initials;
}

(() => {
  fetch('/api/v1/topbar-link')
    .then((res) => res.json())
    .then(({ data }) => {
      const topbar = document.querySelector('.topbar-header');
      topbar.innerHTML = '';
      topbar.insertAdjacentHTML('afterbegin', `
        <div class="container">
          <div class="row">
            <a href="${data.url}">
              <b>${data.title}</b>
            </a>
          </div>
        </div>
      `);
    })
    .catch(console.error);
  fetch('/api/v1/auth/me', {
    credentials: 'include',
  })
    .then((res) => res.json())
    .then((user) => {
      const nav = document.querySelector('.navbar-nav');
      const loginLink = nav.querySelector('.nav-item:last-child');
      loginLink.remove();
      const getFreeTrialLink = nav.querySelector('.nav-item:last-child');
      getFreeTrialLink.remove();
      nav.insertAdjacentHTML('beforeend', `
      <div class="user-menu-dropdown nav-item dropdown">
        <a aria-expanded="false" role="button" class="dropdown-toggle link" tabindex="0" href="#" data-toggle="dropdown">
          <div class=" user-menu-btn">
            <div class="avatar">
              <span class="avatar-fallback">${getUserInitials(user)}</span>
            </div>
            <span class="nav-item user-name">${user.firstName} ${user.lastName}</span>
            <svg class="icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
              <path d="m7 10 5 5 5-5z"></path>
            </svg>
          </div>
        </a>
        <div aria-labelledby="" class="dropdown-menu">
          <a aria-selected="false" class="pre-header-dropdown-item dropdown-item" href="/customer-area/">
            <svg class="icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
              <path d="M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"></path>
            </svg>
            &nbsp;Get downloads
          </a>
          <a aria-selected="true" class="pre-header-dropdown-item dropdown-item active" href="/customer-area/licenses/">
            <svg class="icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
              <path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path>
            </svg>
            &nbsp;Manage users and licenses
          </a>
          <a aria-selected="false" class="pre-header-dropdown-item dropdown-item" href="/customer-area/profile/">
            <svg class="icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"></path>
            </svg>
            &nbsp;Edit profile
          </a>
          <a aria-selected="false" class="pre-header-dropdown-item dropdown-item" href="/auth/logout/">
            <svg class="icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
              <path d="m17 8-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4-4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V5z"></path>
            </svg>
            &nbsp;Log out
          </a>
        </div>
      </div>
      `);
    })
    .catch(console.error);
})();
